import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a1908c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "distribution-groups-wrapper",
  class: "main-content-wrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "distribution-groups-title grid" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "page-title col-3 mt-3" }, "選定ユーザー一覧")
], -1))
const _hoisted_3 = { class: "target-customer-list-body mt-3" }
const _hoisted_4 = { class: "p-input-icon-left h-auto box-search" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_6 = { class: "list-groups mt-3" }
const _hoisted_7 = { class: "w-full text-right pr-3" }
const _hoisted_8 = { class: "grid mt-3 justify-content-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center w-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-2 p-dialog-title" }, "指定したユーザーを除外設定しますか?")
], -1))
const _hoisted_10 = { class: "grid mt-5 mb-5 justify-content-center" }

import { ref, onBeforeMount, computed } from "vue";
import { get, set } from "@vueuse/core";

// Vuex・PrimeVue関連のインポート
import { useStore } from "vuex";
import { useToast } from "primevue/usetoast";
import { PageState } from "primevue/paginator";
import Toast from "primevue/toast";
import Checkbox from "primevue/checkbox";

// コンポーネント・サービスのインポート
import Paginator from "@/clinic/components/atoms/Paginator/index.vue";
import { notityErrorMsg, notifySuccessMsg } from "@/clinic/utils/notify-utils";
import Grid from "@/clinic/components/atoms/Grid/index.vue";
import { DEFAULT_MEDIUM_PAGINATOR_ROWS } from "@/clinic/typings/constants/paginator";
import DistributionGroupService from "@/clinic/services/distribution_group_service";
import { ApiBasePaginatorReq, ICustomer } from "@/clinic/typings";
import { BasicCustomerFilterFields } from "@/clinic/typings/enums/customer";

/**
 * Vuexストア
 * @type {Store}
 */
type IColumn = {
  field: string;
  header: string;
  class?: string;
  style?: string;
  icon?: unknown;
};
/**
 * 検索処理
 * @param {Event} event - 検索イベント
 */
enum LineLinkedClassEnum {
  true = "icon-lms icon-lms_link text-line-green mx-auto",
}

/**
 * グリッドカラム定義
 * @type {Ref<IColumn[]>}
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'TargetCustomers',
  props: {
    distributionGroupId: null,
    targetCustomers: null
  },
  emits: ["resourcesFn", "changeTargetViewType", "setRejectedCustomerIds"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  /** 配信グループID */
  distributionGroupId: string | number;
  /** 対象顧客リスト */
  targetCustomers: Record<string, unknown>[];
};

/**
 * ルーティン配信対象顧客一覧コンポーネント
 *
 * このコンポーネントはルーティン配信グループの対象顧客一覧を管理し、
 * 以下の機能を提供します：
 * - 対象顧客の検索・表示
 * - 顧客の除外設定
 * - ページネーション機能
 * - LINE紐付け状況の表示
 *
 * @component TargetCustomers
 * @description ルーティン配信グループの対象顧客一覧を管理するコンポーネント
 */

// Vue関連のインポート
const store = useStore();

/**
 * トースト通知
 * @type {UseToast}
 */
const toast = useToast();

/**
 * 最初のページ番号
 * @type {Ref<number>}
 */
const first = ref(0);

/**
 * 1ページあたりの行数
 * @type {Ref<number>}
 */
const rows = ref(DEFAULT_MEDIUM_PAGINATOR_ROWS);

/**
 * 総件数
 * @type {Ref<number>}
 */
const totalCount = ref(0);

/**
 * 現在のページ番号
 * @type {Ref<number>}
 */
const page = ref(0);

/**
 * 下部ページネーター
 * @type {Ref<InstanceType<typeof Paginator> | null>}
 */
const pgBot = ref<InstanceType<typeof Paginator> | null>(null);

/**
 * ダイアログ表示フラグ
 * @type {Ref<boolean>}
 */
const visible = ref(false);

/**
 * 対象顧客リスト
 * @type {Ref<any[]>}
 */
const targetCustomers = ref<Record<string, unknown>[]>([]);

/**
 * 検索キーワード
 * @type {Ref<string>}
 */
const searchTerm = ref("");

/**
 * ローディング状態
 * @type {Ref<boolean>}
 */
const loading = ref(false);

/**
 * 選択された顧客リスト
 * @type {Ref<any[]>}
 */
const listChosen = ref<string[]>([]);

/**
 * クリニックID
 * @type {Ref<number>}
 */
const clinicId = ref(0);

/**
 * カラム定義の型
 * @type {Object}
 */
const onSearch = async (event: Event) => {
  const target = event.target as HTMLInputElement;
  set(searchTerm, target?.value || "");
  // 検索時はページをリセット
  set(page, 0);
  set(first, 0);
  await loadCustomers();
};

/**
 * イベントエミッター
 */


/**
 * 対象設定に戻る処理
 */
const onBackToTargetSetting = () => {
  emits("resourcesFn", 2);
  emits("changeTargetViewType", "setting");
};

/**
 * ページネーター用パラメータ
 * @type {ComputedRef<ApiBasePaginatorReq>}
 */
const paginatorParams = computed(
  (): ApiBasePaginatorReq => ({ term: get(searchTerm), page: get(page) + 1, rows: get(rows) } as ApiBasePaginatorReq)
);

/**
 * ページング処理
 * @param {string} fromId - 元のID
 * @param {PageState} pageState - ページ状態
 */
const paging = async (_fromId: string, { page: newPage, first: newFirst }: PageState) => {
  // 現在のページと同じ場合は何もしない
  if (newPage === get(page)) return;

  // ページ番号を更新
  set(page, newPage);

  // firstの値を更新（PrimeVueから渡された値を使用）
  set(first, newFirst);

  await loadCustomers();
};

/**
 * 顧客データ読み込み処理
 * @param {any} pgRefTop - 上部ページネーター参照
 * @param {any} pgRefBot - 下部ページネーター参照
 * @param {number} newPage - 新しいページ番号
 */
const loadCustomers = async () => {
  set(loading, true);
  const params = {
    clinic_id: clinicId.value,
    ...get(paginatorParams),
    filter_by: BasicCustomerFilterFields,
  };
  const { data } = await DistributionGroupService.getTargetCustomers(props.distributionGroupId, params);
  const { customers: customersData, meta } = get(data);
  const { total_count } = meta;
  set(
    targetCustomers,
    get(customersData).map((cus: Record<string, unknown>) => {
      return {
        ...cus,
        address: `${cus.address || ""} ${cus.address_number || ""}`,
        linked_line: (Array.isArray(cus?.line_account_ids) ? cus.line_account_ids : []).length != 0,
      } as unknown as ICustomer;
    })
  );
  set(totalCount, get(total_count));
  set(loading, false);
};

/**
 * 対象顧客削除処理
 */
const onDeleteTargetCustomers = async () => {
  const params = {
    clinic_id: clinicId.value,
    customer_ids: listChosen.value,
  };
  await DistributionGroupService.deleteTargetCustomers(
    props.distributionGroupId,
    params,
    () => {
      notifySuccessMsg(toast, "指定したユーザーを除外しました");
      set(visible, false);
      loadCustomers();
      emits("setRejectedCustomerIds", listChosen.value);
      listChosen.value = [];
    },
    () => notityErrorMsg(toast, "エラーが発生しました")
  );
};

/**
 * コンポーネントのプロパティ定義
 * @type {Object}
 */


/**
 * LINE紐付けクラス列挙型
 * @enum {string}
 */
const columns = ref<IColumn[]>([
  { field: "action", header: "", class: "col-1", style: "font-size: 13px; width: 60px" },
  { field: "code", header: "カルテNo.", class: "col-1", style: "width: 90px" },
  {
    field: "linked_line",
    header: "LINE紐付け",
    class: "col-1 text-center",
    style: "white-space:nowrap",
    icon: LineLinkedClassEnum,
  },
  { field: "name", header: "名前", class: "col-2" },
  { field: "phone", header: "電話番号", class: "col-2" },
  { field: "address", header: "住所" },
  { field: "comment", header: "メモ" },
]);

/**
 * ダイアログ閉じる処理
 */
const onClosedDialog = () => {
  set(visible, false);
};

/**
 * アイテムクリック処理
 * @param {any} event - クリックイベント
 * @param {any} item - クリックされたアイテム
 */
const onItemClick = async () => {
  // Implement later
};

/**
 * コンポーネントマウント前の処理
 */
onBeforeMount(async () => {
  const currentClinicId = await store.dispatch("authClient/getClinicIdCookie");
  set(clinicId, currentClinicId);
  await loadCustomers();
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_InputText, {
          placeholder: "カルテNo.、お名前",
          onKeyup: _withKeys(onSearch, ["enter"]),
          modelValue: searchTerm.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event))
        }, null, 8, ["onKeyup", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(Grid, {
          items: targetCustomers.value,
          columns: columns.value,
          loading: loading.value,
          onOnItemClick: onItemClick
        }, {
          action: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(Checkbox), {
                modelValue: listChosen.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((listChosen).value = $event)),
                inputId: data.code,
                name: data.code,
                value: data.code
              }, null, 8, ["modelValue", "inputId", "name", "value"])
            ])
          ]),
          _: 1
        }, 8, ["items", "columns", "loading"]),
        _createVNode(Paginator, {
          id: "pg-bot",
          ref_key: "pgBot",
          ref: pgBot,
          modelValue: first.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((first).value = $event)),
          onPaging: paging,
          totalRecords: totalCount.value,
          rows: rows.value,
          class: "mt-2",
          paginatorId: "pg-bot"
        }, null, 8, ["modelValue", "totalRecords", "rows"]),
        _createVNode(_unref(Toast), { position: "top-center" })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Button, {
          class: "col-2 temp-delete-btn ml-5",
          label: "指定ユーザーを除外する",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (visible.value = true)),
          disabled: listChosen.value.length == 0
        }, null, 8, ["disabled"]),
        _createVNode(_component_Button, {
          class: "col-2 create-btn ml-5",
          label: "確認完了・戻る",
          onClick: onBackToTargetSetting
        })
      ]),
      _createVNode(_component_Dialog, {
        visible: visible.value,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
        modal: "",
        class: "mx-5 dialog-note border-0",
        draggable: false
      }, {
        header: _withCtx(() => [
          _hoisted_9
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_Button, {
              label: "キャンセル",
              class: "p-button p-button-light mr-3 ml-5",
              onClick: onClosedDialog
            }),
            _createVNode(_component_Button, {
              label: "外して戻る",
              class: "p-button confirm-delete-btn mr-2 ml-4",
              onClick: onDeleteTargetCustomers
            })
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}
}

})